<template>
  <div style="height: 100%">
    <v-card style="height: 100%">
      <v-img
        :src="item.thumbnail"
        aspect-ratio="2.75"
        contain
        class="clickable"
        @click="dialog = true; carouselValue = 0"
      />
      <!-- :background-color="getImgColor()" -->

      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">{{ item.name }}</h3>
          <div>{{ item.descriptionSnippet }}</div>
        </div>
      </v-card-title>

      <v-card-actions>
        <v-btn 
          flat 
          color="orange"
          @click="dialog = true; carouselValue = 0">{{ $t('read_more') }}</v-btn>
        <v-btn 
          v-if="item.downloadable" 
          :href="item.downloadUrl" 
          :target="(item.download_in_newtab) ? '_blank' : ''" 
          flat 
          color="orange">{{ $t('download') }}</v-btn>
        <v-btn 
          v-if="item.openable" 
          :href="item.url" 
          flat 
          color="orange" 
          target="_blank">{{ $t('view') }}</v-btn>
        <v-btn 
          v-if="item.github" 
          :href="item.github" 
          flat 
          color="orange" 
          target="_blank">{{ $t('view_github_small') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-layout 
      row 
      justify-center>
      <v-dialog 
        v-model="dialog" 
        :max-width="(this.$vuetify.breakpoint === 'xl') ? '60vh' : '90vh'">
        <v-card class="portfolio-dialog">
          <v-toolbar 
            dark 
            color="primary">
            <v-btn 
              icon 
              dark 
              @click.native="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ item.name }}</v-toolbar-title>
          </v-toolbar>
          <v-carousel 
            v-if="item.images && item.images.length > 0" 
            v-model="carouselValue">
            <v-carousel-item
              v-for="(image,i) in item.images"
              :key="i"
              :src="image.url"
              position="top"
            />
          </v-carousel>
          <v-card-text v-html="item.fullHtmlDescription"/>
          <v-card-actions style="position: absolute; bottom: 0; right: 0">
            <v-btn 
              v-if="item.downloadable" 
              :href="item.downloadUrl" 
              :target="(item.download_in_newtab) ? '_blank' : ''" 
              color="orange">{{ $t('download') }}</v-btn>
            <v-btn 
              v-if="item.openable" 
              :href="item.url" 
              color="orange" 
              target="_blank">{{ $t('view') }}</v-btn>
            <v-btn 
              v-if="item.github" 
              :href="item.github" 
              color="orange" 
              target="_blank">{{ $t('view_github') }}</v-btn>
            <v-btn @click="dialog = false">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<style lang="scss">
.portfolio-dialog {
  height: 50vh;
  min-height: 800px;
}
.corrected-action-alignment {
  bottom: 0;
  position: absolute;
}
.clickable {
  cursor: pointer;
}
</style>


<script>
  export default {
    name: 'PortfolioItem',
    props: {
        item: {
            type: Object,
            default() {
                return { name: 'Portfolio item' };
            }
        }
    },
    data () {
      return {
        dialog: false,
        carouselValue: 0
      }
    }
  }
</script>